<!------------------------------

      Page Actions

------------------------------->
<div class="tw-flex tw-justify-end tw-gap-2 tw-mb-3">

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</div>

<!------------------------------

    Table wrapper

------------------------------->
<sb-table-wrapper-new
  headline="{{'lang.globals.addAdmin' | translate}}"
  [isInModalContext]="true"
  [itemsData]="users"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'clients'">

  <!------------------------------

    Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

       Table Header

 ------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        #
      </th>
      <th>
        {{ 'lang.globals.userName' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.email' | translate }}
      </th>
      <th class=" sticky-col last-col tw-z-20">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

Table Body

------------------------------->
  <ng-template #tbody let-user>
    <tr>
      <td>
        {{ user.id }}
      </td>
      <td>
        {{ user.username }}
      </td>
      <td>
        {{ user.name }}
      </td>
      <td>
        {{ user.email }}
      </td>
      <td class="sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="user.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(user, $event)"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>
  <!------------------------------

    Card Element

------------------------------->
  <!-- No card element -->

</sb-table-wrapper-new>
